import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage } from "../../../../config/constants";
//Components
import { FooterContainer, SubmitDiv, ContinueButton, CancelButton, BackButton } from "./styles";

const Footer = ({ handleSubmit, showApps, handleShowApps }) => {
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  return (
    <FooterContainer>
      {!showApps ? (
        <SubmitDiv>
          <ContinueButton onClick={handleShowApps}>{t("addPatient_continueButton")}</ContinueButton>
          <CancelButton to={`${pathHomePage}/home/${clinicianData.token}`}>{t("cancel")}</CancelButton>
        </SubmitDiv>
      ) : (
        <SubmitDiv>
          <ContinueButton onClick={handleSubmit}>{t("addPatient_createButton")}</ContinueButton>
          <BackButton onClick={handleShowApps}>{t("back")}</BackButton>
        </SubmitDiv>
      )}
    </FooterContainer>
  );
};

export default Footer;
